<mat-nav-list>
    <a (click)="acceptAllTransfers()" mat-list-item  aria-label="Button that lets you view your tickets.">
        <h5 class="text-uppercase" mat-line><i class="fa fa-check fa-fw mr-3"></i><strong>Accept</strong></h5>
        <span mat-line>Tap here to accept your ticket transfer and be ready for gameday.</span>
    </a>
    <a (click)="declineAllTransfers()" mat-list-item  aria-label="Button that lets you print your tickets.">
        <h5 class="text-uppercase" mat-line><i class="fa fa-close fa-fw mr-3"></i><strong>Decline</strong></h5>
        <span mat-line>Tap here to decline your ticket transfer.</span>
    </a>
</mat-nav-list>